import { useBalance, useReadContract } from "wagmi";
import { erc20Abi } from "viem";

const NATIVE = "0x0000000000000000000000000000000000000000";

export function useTokenBalance({ address, token, chainId }) {
  const isNative = token?.address?.toLowerCase() === NATIVE;

  const nativeQ = useBalance({
    address,
    chainId,
    query: { enabled: !!address && !!token && isNative, refetchInterval: 20_000 },
  });

  const erc20Q = useReadContract({
    address: token?.address,
    abi: erc20Abi,
    functionName: "balanceOf",
    args: address ? [address] : undefined,
    chainId,
    query: { enabled: !!address && !!token && !isNative, refetchInterval: 20_000 },
  });

  if (!token) return { data: null, decimals: 18, isLoading: false };

  if (isNative)
    return {
      data: nativeQ.data?.value ?? null,
      decimals: token.decimals,
      isLoading: nativeQ.isLoading,
    };
  return {
    data: erc20Q.data ?? null,
    decimals: token.decimals,
    isLoading: erc20Q.isLoading,
  };
}
